/**
 * Map Firebase Auth error codes to user-friendly messages.
 * @param { { code?: string, message?: string } } error
 * @returns { string }
 */
export function getAuthErrorMessage(error) {
  if (!error) return 'An error occurred. Please try again.';
  const code = error.code || '';
  const message = error.message || '';
  const byCode = {
    'auth/email-already-in-use': 'This email is already registered. Try logging in.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/operation-not-allowed': 'Email/password sign-in is not enabled. Contact support.',
    'auth/weak-password': 'Password should be at least 8 characters.',
    'auth/user-disabled': 'This account has been disabled. Contact support.',
    'auth/user-not-found': 'Invalid email or password.',
    'auth/wrong-password': 'Invalid email or password.',
    'auth/invalid-credential': 'Invalid email or password.',
    'auth/too-many-requests': 'Too many attempts. Please try again later.',
    'auth/requires-recent-login': 'Please log out and log in again, then try this action.',
    'auth/network-request-failed': 'Network error. Check your connection and try again.',
  };
  return byCode[code] || message || 'An error occurred. Please try again.';
}
